import cx from 'classnames';
import { Component, ReactNode } from 'react';

import Button from '@navi/web-ui/lib/primitives/Button/index';
import Typography from '@navi/web-ui/lib/primitives/Typography/index';
import image from '../assets/images/error-boundary.svg';
import Refresh from '../assets/images/icons/Refresh';
import styles from './DefaultLayout.module.scss';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { ErrorBoundaryEvents } from '@cp/src/service/clickStream.constant';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class Layout extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch() {
    //this will help to log files to glitchtip
    this.setState({
      hasError: true
    });
    // Sentry.captureMessage('Error form error boundary');
    addClickstreamEvent(ErrorBoundaryEvents.FRONT_END_ERROR);
  }

  handleRefresh = () => window.location.reload();

  render() {
    if (this.state.hasError) {
      return (
        <div className={cx([styles.pageLayout, styles.centerAlign])}>
          <img className={styles.errorImage} src={image} alt="error" />
          <Typography className={styles.descriptionTextError} variant="p2">
            Something went wrong. Please reload or try after sometime
          </Typography>
          <Button className={styles.refreshButton} onClick={this.handleRefresh} variant="primary">
            {' '}
            <Refresh /> Reload
          </Button>
        </div>
      );
    }

    return <>{this.props.children}</>;
  }
}

export default Layout;
